import React from "react"

export default function ({ poster }) {
  const points = poster.knowledge_points || 0

  return (
    <span className="user-knowledge-points">
      {interpolate(
        pgettext("poster knowledge points", "%(points)s knowledge points"),
        { points: points },
        true
      )}
    </span>
  )
}
